<div class="container">
  <div class="row">
    <div class="col">
      <div class="cards__container d-flex flex-column mx-auto">
        <h2 class="mb-0 text-center text-lg-start fw-extrabold">
          What you can do today
        </h2>
        <div
          class="cards d-flex flex-column flex-lg-row align-items-center justify-content-center flex-wrap"
        >
          <div
            class="card d-flex flex-column align-items-center justify-content-start"
          >
            <div class="card__inner d-flex flex-column align-items-center">
              <div class="icon">
                <img
                  src="/assets/img/t1d-family-history/card-heart-icon.svg"
                  width="124"
                  height="106"
                  alt="A family of three"
                />
              </div>
              <div class="text">
                <p class="mb-0 text-center fw-bold">
                  Ask patients about family history of T1D and educate about
                  risk factors
                </p>
              </div>
            </div>
          </div>
          <div
            class="card d-flex flex-column align-items-center justify-content-start"
          >
            <div class="card__inner d-flex flex-column align-items-center">
              <div class="icon">
                <img
                  src="/assets/img/t1d-family-history/card-magnifying-glass-icon.svg"
                  width="141"
                  height="123"
                  alt="A magnifying glass looking at an exclamation point"
                />
              </div>
              <div class="text">
                <p class="mb-0 text-center fw-bold">
                  Provide guidance on T1D progression, the autoimmune response
                  that causes the disease, and how to spot it, and potentially
                  improved long term outcomes from early detection.
                </p>
              </div>
            </div>
          </div>
          <div
            class="card d-flex flex-column align-items-center justify-content-start"
          >
            <div class="card__inner d-flex flex-column align-items-center">
              <div class="icon">
                <img
                  src="/assets/img/t1d-family-history/card-doctors-icon.svg"
                  width="124"
                  height="125"
                  alt="A care team"
                />
              </div>
              <div class="text">
                <p class="mb-0 text-center fw-bold">
                  Help patients make a plan for autoantibody screening before
                  symptoms develop
                </p>
              </div>
            </div>
          </div>
        </div>
        <h2 class="text-primary mb-0 fw-extrabold">
          Click below to download the full survey findings.
        </h2>
        <div class="cards__btn">
          <div
            class="action-plan__btn"
            global-button
            [buttonData]="cardButton"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
